export const environment = {
    production: true,
    apiUri: "https://miaas-api.dataanalysis.fb01.h-brs.de",
};
